module.exports = __webpack_public_path__ + "logout-4b927bda7e801975f2e66c818abf7c70.svg";